import {
  useRecordContext,
  useDataProvider,
  useNotify,
  Button,
  Confirm,
  useRefresh,
} from 'react-admin';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { useState } from 'react';

export const RemoveUserFromGroupButton = () => {
  const [open, setOpen] = useState(false);
  const userRecord = useRecordContext(); // This gets the user record from the Datagrid
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click navigation
    setOpen(true);
  };
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = async () => {
    if (!userRecord) return;

    try {
      await dataProvider.update('users', {
        id: userRecord.id,
        data: { groupId: null },
        previousData: userRecord,
      });

      notify('User removed from group successfully', { type: 'success' });
      setOpen(false);
      // Refresh only the current view without navigation
      refresh();
    } catch (error) {
      notify(error instanceof Error ? error.message : 'Error removing user from group', {
        type: 'error',
      });
    }
  };

  if (!userRecord) return null;

  return (
    <>
      <Button
        label="Remove"
        onClick={handleClick}
        startIcon={<PersonRemoveIcon />}
        color="error"
        size="small"
      />
      <Confirm
        isOpen={open}
        title="Remove User from Group"
        content={`Are you sure you want to remove ${userRecord.username} from this group?`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
